

export class TyreAllOutputDataWithStatus implements ITyreAllOutputDataWithStatus {
    /** The auto-generated id of the tyre master */
    tyre_id!: number;
    /** The company name with 255 character */
    company_name!: string;
    /** The company name with 255 character */
    branch!: string;
    /** The tyre brand name with 255 character */
    tyre_brand_name!: string;
    /** The tyre model name with 255 character */
    tyre_model_name!: string;
    /** The tyre serial number with 500 character limit */
    tyre_serial_number!: string;
    /** The RFID tag tag with 100 character limit */
    rfid_tag!: string;
    /** The manufactured date with 10 character limit */
    manufacture_date!: string;
    /** The tyre size with 200 character limit */
    tyre_size!: string;
    /** The tread pattern 100 character limit */
    tread_pattern!: string;
    /** The purchase date with 10 character limit */
    purchase_date!: string;
    /** The price of tyre */
    price!: number;
    /** The tread depth of tyre */
    tread_depth!: number;
    /** The tyre predicted distance with 100 character limit */
    tyre_predicted_distance!: string;
    /** The tyre condition should be New,Retreaded,Repaired,Re-grooved */
    tyre_condition!: string;
    /** The tyre distance with 100 character limit */
    tyre_distance!: string;
    /** The tyre image with 2048 character limit */
    tyre_image!: string;
    /** Manage status of tyre. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ITyreAllOutputDataWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyre_id = _data["tyre_id"];
            this.company_name = _data["company_name"];
            this.branch = _data["branch"];
            this.tyre_brand_name = _data["tyre_brand_name"];
            this.tyre_model_name = _data["tyre_model_name"];
            this.tyre_serial_number = _data["tyre_serial_number"];
            this.rfid_tag = _data["rfid_tag"];
            this.manufacture_date = _data["manufacture_date"];
            this.tyre_size = _data["tyre_size"];
            this.tread_pattern = _data["tread_pattern"];
            this.purchase_date = _data["purchase_date"];
            this.price = _data["price"];
            this.tread_depth = _data["tread_depth"];
            this.tyre_predicted_distance = _data["tyre_predicted_distance"];
            this.tyre_condition = _data["tyre_condition"];
            this.tyre_distance = _data["tyre_distance"];
            this.tyre_image = _data["tyre_image"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TyreAllOutputDataWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TyreAllOutputDataWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyre_id"] = this.tyre_id;
        data["company_name"] = this.company_name;
        data["branch"] = this.branch;
        data["tyre_brand_name"] = this.tyre_brand_name;
        data["tyre_model_name"] = this.tyre_model_name;
        data["tyre_serial_number"] = this.tyre_serial_number;
        data["rfid_tag"] = this.rfid_tag;
        data["manufacture_date"] = this.manufacture_date;
        data["tyre_size"] = this.tyre_size;
        data["tread_pattern"] = this.tread_pattern;
        data["purchase_date"] = this.purchase_date;
        data["price"] = this.price;
        data["tread_depth"] = this.tread_depth;
        data["tyre_predicted_distance"] = this.tyre_predicted_distance;
        data["tyre_condition"] = this.tyre_condition;
        data["tyre_distance"] = this.tyre_distance;
        data["tyre_image"] = this.tyre_image;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITyreAllOutputDataWithStatus {
    /** The auto-generated id of the tyre master */
    tyre_id: number;
    /** The company name with 255 character */
    company_name: string;
    /** The company name with 255 character */
    branch: string;
    /** The tyre brand name with 255 character */
    tyre_brand_name: string;
    /** The tyre model name with 255 character */
    tyre_model_name: string;
    /** The tyre serial number with 500 character limit */
    tyre_serial_number: string;
    /** The RFID tag tag with 100 character limit */
    rfid_tag: string;
    /** The manufactured date with 10 character limit */
    manufacture_date: string;
    /** The tyre size with 200 character limit */
    tyre_size: string;
    /** The tread pattern 100 character limit */
    tread_pattern: string;
    /** The purchase date with 10 character limit */
    purchase_date: string;
    /** The price of tyre */
    price: number;
    /** The tread depth of tyre */
    tread_depth: number;
    /** The tyre predicted distance with 100 character limit */
    tyre_predicted_distance: string;
    /** The tyre condition should be New,Retreaded,Repaired,Re-grooved */
    tyre_condition: string;
    /** The tyre distance with 100 character limit */
    tyre_distance: string;
    /** The tyre image with 2048 character limit */
    tyre_image: string;
    /** Manage status of tyre. 0 For De-active, 1 For Active */
    status: number;
}

